import * as React from "react"
import * as AllocationDomain from "../../../../domain/sfp/allocation-domain"
import * as ChapterDomain from "../../../../domain/sfp/chapter-domain"
import * as TaxDomain from "../../../../domain/sfp/tax-domain"
import * as Model from "../../../../model"

export default class ObservationFormPart extends React.Component<Props, State> {	
	render() {
		let { disabled }= this.props;
		return <section className="section">
			<h2 className="title">Constat rétrospectif et prospectif</h2>

			<div className="columns is-multiline">
				{this.getSectionsConfiguration().map((conf, i) =>
				<section
				className="column is-half-tablet is-one-third-widescreen section"
				key={i}>
					<h3 className="title">{conf.title}</h3>

					{conf.tables && <div className="field">
						<label className="checkbox">
							<input name={conf.tables.name} type="checkbox" checked={ this.props.report && this.props.report.includes(conf.tables.name)} disabled={disabled} />&nbsp;
							{conf.tables.label}
						</label>
					</div>}

					{conf.blankTable && <div className="field">
						<label className="checkbox">
							<input name={conf.blankTable.name} type="checkbox" checked={ this.props.report && this.props.report.includes(conf.blankTable.name)} disabled={disabled} />&nbsp;
							{conf.blankTable.label}
						</label>
					</div>}

					{conf.synthesis && <div className="field">
						<label className="checkbox">
							<input name={conf.synthesis.name} type="checkbox" checked={ this.props.report && this.props.report.includes(conf.synthesis.name)} disabled={disabled} />&nbsp;
							{conf.synthesis.label}
						</label>
					</div>}

					{/* Graphiques */}
					{conf.charts && <div>
						{/* Graphiques globaux */}
						{conf.charts.globalName && <div className="field">
							<label className="checkbox">
								<input name={conf.charts.globalName} type="checkbox" checked={ this.props.report && this.props.report.includes(conf.charts.globalName)} disabled={disabled} />&nbsp;
								Inclure les graphiques globaux
							</label>
						</div>}
						{/* Fin Graphiques globaux */}

						{/* Chapitres, taxes et dotations */}
						{conf.charts.chaptersName && <div className="field">
							<div className="select is-multiple is-fullwidth">
								<select name={conf.charts.chaptersName} size={5} multiple>
									{this.renderOptions(conf)}
								</select>
							</div>
						</div>}
						{/* Fin Chapitres, taxes et dotations */}

						{/* Graphiques par chapitre */}
						{conf.charts.onePerChapter && <div className="field">
							<label className="checkbox">
								<input
								name={conf.charts.onePerChapter.name}
								type="checkbox" checked={this.props.report && this.props.report.includes(conf.charts.onePerChapter.name)} disabled={disabled} />&nbsp;
								{conf.charts.onePerChapter.inputLabel}
							</label>
						</div>}
						{/* Fin Graphiques par chapitre */}

						{/* Graphiques par chapitre par habitant */}
						{conf.charts.onePerChapterPerInhabitant && <div className="field">
							<label className="checkbox">
								<input
								name={conf.charts.onePerChapterPerInhabitant.name}
								type="checkbox" checked={this.props.report && this.props.report.includes(conf.charts.onePerChapterPerInhabitant.name)} disabled={disabled} />&nbsp;
								{conf.charts.onePerChapterPerInhabitant.inputLabel}
							</label>
						</div>}
						{/* Fin Graphiques par chapitre par habitant */}
					</div>}
					{/* Fin Graphiques */}
				</section>
				)}
			</div>
		</section>
	}

	private getSectionsConfiguration(): SectionConfiguration[] {
		const onePerChapterLabel = "Inclure un graphique par chapitre"
		const onePerChapterPerInhabitantLabel = `${onePerChapterLabel} par habitant`

		return [
			{
				charts: {
					chapters: this.props.receiptsChapters,
					chaptersName: Names.OperationReceipts.Charts.Chapters,
					emptyTitle: "Aucun chapitre disponible",
					globalName: Names.OperationReceipts.Charts.Global,
					onePerChapter: {
						inputLabel: onePerChapterLabel,
						name: Names.OperationReceipts.Charts.OnePerChapter,
					},
					onePerChapterPerInhabitant: {
						inputLabel: onePerChapterPerInhabitantLabel,
						name: Names.OperationReceipts.Charts.OnePerChapterPerInhabitant
					}
				},
				tables: {
					label: "Inclure le tableau des recettes de fonctionnement",
					name: Names.OperationReceipts.Tables,
				},
				blankTable: {
					label: "Inclure le tableau de progression des recettes",
					name: Names.ProgressOperationReceipts.Tables,
				},
				title: "Section Recettes fonctionnement"
			},
			{
				charts: {
					chapters: this.props.expenseChapters,
					chaptersName: Names.OperationExpense.Charts.Chapters,
					emptyTitle: "Aucun chapitre disponible",
					globalName: Names.OperationExpense.Charts.Global,
					onePerChapter: {
						inputLabel: onePerChapterLabel,
						name: Names.OperationExpense.Charts.OnePerChapter,
					},
					onePerChapterPerInhabitant: {
						inputLabel: onePerChapterPerInhabitantLabel,
						name: Names.OperationExpense.Charts.OnePerChapterPerInhabitant
					}
				},
				tables: {
					label: "Inclure le tableau des dépenses de fonctionnement",
					name: Names.OperationExpense.Tables,
				},
				blankTable: {
					label: "Inclure le tableau de progression des dépenses",
					name: Names.ProgressOperationExpense.Tables,
				},
				title: "Section Dépenses fonctionnement"
			},
			{				
				tables: {
					label: "Inclure le tableau comparatif dépenses/recettes de fonctionnement",
					name: Names.OperationCompare.Tables,
				},
				blankTable:{
					label: "Inclure le tableau comparatif du prévisionel/réalisé sur l'investissement",
					name: Names.OperationCompare.BlankTable,
				},
				title: "Section Comparaison"
			},
			{
				charts: { globalName: Names.AutoFinancing.Charts.Global },
				tables: {
					label: "Inclure le tableau de formation de l'autofinancement brut et net",
					name: Names.AutoFinancing.Tables,
				},
				title: "Formation de l’autofinacement brut et net"
			},
			{
				charts: { globalName: Names.Investment.Charts.Global },
				tables: {
					label: "Inclure le tableau de la section investissement",
					name: Names.Investment.Tables,
				},
				title: "Section Investissement"
			},
			{
				charts: {
					taxes: this.props.taxes,
					chaptersName: Names.Tax.Charts.Taxes,
					emptyTitle: "Aucune taxe disponible",
					globalName: Names.Tax.Charts.Global,
					onePerChapter: {
						inputLabel: "Inclure un graphique par taxe",
						name: Names.Tax.Charts.OnePerTax,
					},
					onePerChapterPerInhabitant: {
						inputLabel: "Inclure un graphique par taxe par habitant",
						name: Names.Tax.Charts.OnePerTaxPerInhabitant
					}
				},
				title: "Fiscalité"
			},
			{
				charts: {
					allocations: this.props.allocations,
					chaptersName: Names.Allocations.Charts.Allocations,
					emptyTitle: "Aucune dotation disponible",
					globalName: Names.Allocations.Charts.Global,
					onePerChapter: {
						inputLabel: "Inclure un graphique par dotation",
						name: Names.Allocations.Charts.OnePerAllocation
					},
					onePerChapterPerInhabitant: {
						inputLabel: "Inclure un graphique par dotation par habitant",
						name: Names.Allocations.Charts.OnePerAllocationPerInhabitant
					}
				},
				title: "Dotations"
			},
			{
				synthesis:{
					name:Names.Synthesis.Synthesis,
					label:"Inclure un graphique de synthèse"
				},
				title: "Synthèse de l'investissement et du fonctionnement prévisionnel"
			},
		];
	}

	private renderOptions(conf: SectionConfiguration): React.ReactNode {
		if (conf.charts.allocations && conf.charts.allocations.length) {
			return conf.charts.allocations.map((alloc, i) => {
				const label = AllocationDomain.allocationLabels[alloc]
				return <option key={i} title={label} selected={this.props.report && this.props.report.includes(conf.charts.chaptersName)} value={alloc}>{label}</option>
			})
		} else if (conf.charts.chapters && conf.charts.chapters.length) {
			return conf.charts.chapters.map((ch, i) => {
				const label = ChapterDomain.titlize(ch)
				const value = ch ? ch.id : null
				return <option key={i} title={label} selected={this.props.report && this.props.report.includes(conf.charts.chaptersName)} value={value}>{label}</option>
			})
		} else if (conf.charts.taxes && conf.charts.taxes.length) {
			return conf.charts.taxes.map((tax, i) => {
				const label = TaxDomain.getTaxLabel(tax)
				return <option key={i} title={label} selected={this.props.report && this.props.report.includes(conf.charts.chaptersName)} value={tax}>{label}</option>
			})
		} else if (conf.charts.emptyTitle) {
			return <option title={conf.charts.emptyTitle} disabled>
				{conf.charts.emptyTitle}
			</option>
		} else {
			const label = "Aucun élément disponible"
			return <option title={label} disabled>{label}</option>
		}
	}
}

export const Names = {
	Allocations: {
		Charts: {
			Global: "observation-allocations-charts-global",
			Allocations: "observation-allocations-charts-allocations",
			OnePerAllocation: "observation-allocations-charts-one-per-allocation",
			OnePerAllocationPerInhabitant: "observation-allocations-charts-one-per-allocation-per-inhabitant"
		}
	},
	AutoFinancing: {
		Tables: "observation-auto-financing-tables",
		Charts: {
			Global: "observation-auto-financing-charts-global",
		}
	},
	Investment: {
		Tables: "observation-investment-tables",
		Charts: {
			Global: "observation-investment-charts-global",
			Chapters: "observation-investment-charts-chapters",
			OnePerChapter: "observation-investment-charts-one-per-chapter",
			OnePerChapterPerInhabitant: "observation-investment-charts-one-per-chapter-per-inhabitant"
		}
	},
	OperationExpense: {
		Tables: "observation-operation-expense-tables",
		Charts: {
			Global: "observation-operation-expense-charts-global",
			Chapters: "observation-operation-expense-charts-chapters",
			OnePerChapter: "observation-operation-expense-charts-one-per-chapter",
			OnePerChapterPerInhabitant: "observation-operation-expense-charts-one-per-chapter-per-inhabitant"
		}
	},
	OperationReceipts: {
		Tables: "observation-operation-receipts-tables",
		Charts: {
			Global: "observation-operation-receipts-charts-global",
			Chapters: "observation-operation-receipts-charts-chapters",
			OnePerChapter: "observation-operation-receipts-charts-one-per-chapter",
			OnePerChapterPerInhabitant: "observation-operation-receipts-charts-one-per-chapter-per-inhabitant"
		}
	},
	ProgressOperationExpense: {
		Tables: "progress-observation-operation-expense-tables",
	},
	ProgressOperationReceipts: {
		Tables: "progress-observation-operation-receipts-tables",
	},
	OperationCompare: {
		Tables: "observation-operation-receipts-expense-compare",
		BlankTable : "observation-prev-real-compare"		
	},
	Tax: {
		Tables: "observation-tax-tables",
		Charts: {
			Global: "observation-tax-charts-global",
			Taxes: "observation-tax-charts-taxes",
			OnePerTax: "observation-tax-charts-one-per-tax",
			OnePerTaxPerInhabitant: "observation-tax-charts-one-per-tax-per-inhabitant"
		}
	},
	Synthesis:{
		Synthesis:"observation-synthesis"
	}
}

export interface Props {
	allocations: AllocationDomain.Allocation[]
	expenseChapters: Model.Chapter[]
	loading?: boolean
	receiptsChapters: Model.Chapter[]
	taxes: TaxDomain.Tax[]
	disabled?: boolean
	report?: any
}

interface SectionChartConfiguration {
	allocations?: AllocationDomain.Allocation[]
	chapters?: Model.Chapter[]
	chaptersName?: string
	emptyTitle?: string
	globalName: string
	onePerChapter?: {
		inputLabel: string
		name: string
	}
	onePerChapterPerInhabitant?: {
		inputLabel: string
		name: string
	}
	taxes?: TaxDomain.Tax[]
}

interface SectionConfiguration {
	charts?: SectionChartConfiguration
	tables?: {
		label: string
		name: string
	}
	blankTable?:{
		label: string
		name: string
	}
	synthesis?:{
		label: string
		name: string	
	}
	title: string
}

interface State {}



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/observation-form-part/index.tsx